module.exports = __webpack_public_path__ + "img/Jump Casting73.3f31b3bd.jpg";